import React from 'react';
import OriginalTemplate from './templates/OriginalTemplate';
import Y2KTemplate from './templates/Y2KTemplate';
import PolaroidTemplate from './templates/PolaroidTemplate';
import GlassTemplate from './templates/GlassTemplate';
import NeonTemplate from './templates/NeonTemplate';
import GradientTemplate from './templates/GradientTemplate';
import PaperTemplate from './templates/PaperTemplate';
import HoloTemplate from './templates/HoloTemplate';
import WatercolorTemplate from './templates/WatercolorTemplate';

/**
 * LivePreview - 即時預覽組件
 *
 * 核心架構修改：直接縮放 Template 組件，與下載圖片完全一致
 * 縮放比例：320 / 1080 = 0.2963，400 / 1350 = 0.2963
 * 優點：預覽與下載 100% 一致，只需維護一套代碼
 */
const LivePreview = ({
  template = 'original',
  language = 'zh',
  calculatedDays = 0,
  relationshipLabel = '在一起',
  detailedTime = null,
  anniversaryDate = null,
  anniversaryType = 'couple',
  quote = ''
}) => {
  const templateProps = {
    language,
    calculatedDays,
    relationshipLabel,
    detailedTime,
    anniversaryDate,
    anniversaryType,
    quote
  };

  const templateMap = {
    original: OriginalTemplate,
    y2k: Y2KTemplate,
    polaroid: PolaroidTemplate,
    glass: GlassTemplate,
    neon: NeonTemplate,
    gradient: GradientTemplate,
    paper: PaperTemplate,
    holo: HoloTemplate,
    watercolor: WatercolorTemplate
  };

  const TemplateComponent = templateMap[template] || OriginalTemplate;

  // 縮放比例：預覽容器 320x400，模板原始尺寸 1080x1350
  const scale = 320 / 1080; // ≈ 0.2963

  return (
    <div
      style={{
        width: '320px',
        height: '400px',
        borderRadius: '16px',
        overflow: 'hidden',
        boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
        position: 'relative',
        flexShrink: 0
      }}
    >
      <div
        style={{
          width: '1080px',
          height: '1350px',
          transformOrigin: 'top left',
          transform: `scale(${scale})`,
          pointerEvents: 'none'
        }}
      >
        <TemplateComponent {...templateProps} />
      </div>
    </div>
  );
};

export default LivePreview;